import type { ReactElement } from 'react'
import type { IAppEvent } from '~/types/event'

import BlockItem from '../BlockItem'

import { EventTypeBadge } from '~/components/Badges'
import MwMLoader from '~/components/MwMLoader'
import { dataNotAvailableText } from '~/const'

interface Props {
  eventsData: IAppEvent[]
  isEventsLoading: boolean
}

const EventsBlock = ({ eventsData, isEventsLoading }: Props): ReactElement => {
  if (isEventsLoading) {
    return <MwMLoader category="item" />
  }

  if (!eventsData.length) {
    return <span>{dataNotAvailableText}</span>
  }

  return (
    <>
      {eventsData.map(({ date, event_type, id, value }) => (
        <BlockItem badge={<EventTypeBadge eventType={event_type} />} date={date} key={id} title={value} />
      ))}
    </>
  )
}

export default EventsBlock
